import { create } from 'zustand';
import { AuthAPI } from '../api';

interface OnboardingState {
  isRunning: boolean;
  stepIndex: number;
}

interface OnboardingActions {
  startTour: () => void;
  stopTour: () => void;
  setStepIndex: (index: number) => void;
  completeTour: (userId: string) => Promise<void>;
  resetTour: (userId: string) => Promise<void>;
}

type OnboardingStore = OnboardingState & OnboardingActions;

export const useOnboardingStore = create<OnboardingStore>()((set) => ({
  isRunning: false,
  stepIndex: 0,

  startTour: () => set({ isRunning: true, stepIndex: 0 }),
  stopTour: () => set({ isRunning: false, stepIndex: 0 }),
  setStepIndex: (index: number) => set({ stepIndex: index }),

  completeTour: async (userId: string) => {
    set({ isRunning: false, stepIndex: 0 });
    try {
      await AuthAPI.completeTutorial(userId);
    } catch (err) {
      console.error('Error completing tutorial:', err);
    }
  },

  resetTour: async (userId: string) => {
    try {
      await AuthAPI.resetTutorial(userId);
      set({ isRunning: true, stepIndex: 0 });
    } catch (err) {
      console.error('Error resetting tutorial:', err);
    }
  },
}));
